import { Injectable } from '@angular/core';

import type { TAnyValue } from '@shared/models';
@Injectable({
    'providedIn': 'root'
})
export class KeyValuePairService {
    private items: Record<string, TAnyValue>;

    constructor() {
        this.items = {};
    }

    public getValue(key: string): TAnyValue {
        return this.items[key];
    }

    public setValue(key: string, value?: TAnyValue): void {
        if (!value) {
            value = '';
        }
        this.items[key] = value;
    }
}
